var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBalsameeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 155,
    viewBox: "0 0 125 155",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.1553 2.5C88.6062 2.5 100.718 16.12 103.306 31.1221C104.601 38.6323 103.519 46.5212 99.5117 53.2637C95.5001 60.0126 88.5786 65.5755 78.2666 68.4619L77.9668 67.5088C87.9922 64.0015 94.206 57.8434 97.3359 50.8535C100.47 43.8544 100.528 35.9836 98.1709 29.0352C95.8131 22.0858 91.049 16.0863 84.5723 12.8105C78.1137 9.54406 69.9049 8.96135 60.5859 12.9121C46.0398 21.6875 41.5691 33.8093 37.4854 49.4443C34.0572 64.8574 35.5665 81.2721 40.2852 96.916C42.7416 99.8091 45.3824 102.54 48.1914 105.093H48.1904C55.6914 111.887 65.755 118.58 76.2441 121.863C86.7139 125.14 97.5477 125.004 106.718 118.269C111.402 113.225 112.834 108.293 112.14 103.877C111.441 99.432 108.573 95.4121 104.475 92.2637C96.2604 85.9535 83.3296 83.3133 73.8984 87.7002C72.6193 88.3547 71.1735 88.6112 69.7471 88.4375L69.7275 88.4355C69.3301 88.3713 68.9373 88.2809 68.5518 88.165L68.5459 88.1631C62.1603 86.1581 61.1568 77.5787 66.5449 73.7129L66.5469 73.7109C71.4835 70.2095 78.4657 69.4309 85.3018 70.1494C91.9361 70.8468 98.5277 72.9636 103.165 75.4941L103.608 75.7402L103.615 75.7441L103.622 75.749C113.436 81.7402 119.072 88.9964 121.333 96.2793C123.595 103.564 122.466 110.831 118.831 116.796C111.555 128.735 94.3169 135.371 74.2852 126.81L74.2822 126.808C62.5979 121.731 52.0244 114.427 43.1484 105.312C49.3623 121.594 58.4743 136.624 70.0537 149.668L69.333 150.36C54.1341 135.756 40.6897 115.649 33.4043 94.1006C18.545 74.8933 8.52135 51.2705 0.908203 28.7402L0.814453 28.4453C-1.03135 22.2552 5.63788 16.4378 11.457 19.6973L11.6758 19.8193C12.754 20.4533 13.6203 21.3964 14.1611 22.5283C14.7344 23.7283 14.9101 25.0787 14.667 26.3857L14.668 26.3867C12.1317 44.2025 19.3193 65.6672 30.2637 83.1992C28.226 74.5676 27.4056 65.688 27.833 56.8193L27.834 56.8115C29.246 35.1718 35.8661 15.7023 57.002 5.31543L57.0186 5.30762L57.0361 5.30078C61.5266 3.50112 66.3129 2.55111 71.1504 2.5H71.1553Z",
    fill: "url(#paint0_linear_135_1335)",
    stroke: "url(#paint1_linear_135_1335)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_135_1335",
    x1: 2.31635,
    y1: 143.064,
    x2: 109.31,
    y2: 7.48709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#C3A363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#DFC988"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7EAA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_135_1335",
    x1: 2.31635,
    y1: 143.064,
    x2: 109.31,
    y2: 7.48709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#C3A363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#DFC988"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7EAA8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalsameeIcon);
export default __webpack_public_path__ + "static/media/balsameeIcon.d02bf28ea82e0dc7fe44c97d8bbdfa21.svg";
export { ForwardRef as ReactComponent };